<template>
  <!-- <h1 class="font-semibold text-ellie-blue text-center py-16 lg:py-[5vw] container-1 text-4xl md:text-[1.111vw] big-screen:text-[5vw] leading-[1] whitespace-pre-line lg:whitespace-normal">{{ "WHAT OUR CLIENTS \nHAVE TO SAY" }}</h1> -->
  <Swiper
    ref="testimonialSlider"
    :modules="[SwiperAutoplay]"
    :loop="true"
    :breakpoints="{
      '240': {
        slidesPerView: 1.2,
      },
      '768': {
        slidesPerView: 2.5,
      },
      '1024': {
        slidesPerView: 2.5,
      }
    }"
    class="testimonial-slider"
    data-aos="fade-up"
    :autoplay="{
      delay: 5000,
      disableOnInteraction: false,
    }"
    @swiper="onSwiper"
    @mouseenter="toggleHover(true , 'drag')" @mouseleave="toggleHover(false, 'default')"
  >
    <SwiperSlide v-for="item in testimonialData" :key="item.id" class="cursor-grab relative h-full px-9 py-8 md:px-[5.556vw] md:py-[3.472vw] big-screen:px-[4.5vw] big-screen:py-[2.604vw] border-r border-t border-black">
      <div class="relative text-ellie-black h-60 md:h-[22vw] big-screen:h-[14vw] font-medium tracking-[1.4] text-lg leading-6 md:leading-normal md:text-[1.667vw] big-screen:text-[1.25vw]">
        <div class="absolute top-0 -left-[7%] font-medium md:text-[2.083vw] big-screen:text-[1.563vw]">“</div>
        <div class="h-full w-full">{{ item.comment }} <span class="font-medium md:text-[2.083vw] big-screen:text-[1.563vw] leading-[0]">”</span></div>
        <div class="absolute bottom-0">
          <span>- </span>
          <span>{{ item.client }}</span>
        </div>
      </div>
    </SwiperSlide>
  </Swiper>
</template>

<script setup>
const mainStore = useMainStore();

const testimonialData = [
  {
    id: 1,
    comment: 'Thank you for putting us in the right direction from the start of planning to the execution of the project.',
    client: 'NUS'
  },

  {
    id: 2,
    comment: "Great work within many constraints within the project. The team puts in a lot of thoughts in the discovery phase, taking the initiatives to tell us what would and wouldn't work for our campaign.",
    client: 'KAO'
  },

  {
    id: 3,
    comment: 'Quality work and going the extra mile to understand what we are looking for despite the tight deadlines; it saved us a lot of time during the creative process.',
    client: 'Martell'
  },

  {
    id: 4,
    comment: 'Thank you for putting us in the right direction from the start of planning to the execution of the project.',
    client: 'NUS'
  },

  {
    id: 5,
    comment: "Great work within many constraints within the project. The team puts in a lot of thoughts in the discovery phase, taking the initiatives to tell us what would and wouldn't work for our campaign.",
    client: 'KAO'
  },

  {
    id: 6,
    comment: 'Quality work and going the extra mile to understand what we are looking for despite the tight deadlines; it saved us a lot of time during the creative process.',
    client: 'Martell'
  },

];

const testimonialSlider = ref();
let mouseX;
let mouseY;
const onSwiper = (swiper) => {
  const customCursor = document.getElementById('circle-cursor');
  testimonialSlider.value = swiper;

  const updateCursorPosition = (x, y) => {
    if (customCursor) {
      customCursor.style.transform = `translateX(${x-12}px) translateY(${y-12}px)`;
    }
  };

  swiper.on('touchStart', () => {
    const payload = {
      start: true,
      move: false,
    };
    mainStore.toggleTouchEvent(payload);
  });

  swiper.on('touchEnd', (e) => {
    updateCursorPosition(0, 0);
    const x = e.touches.currentX - e.touches.startX;
    const y = e.touches.currentY - e.touches.startY;
    customCursor.style.left = `${mouseX + x}px`;
    customCursor.style.top = `${mouseY + y}px`;
    const payload = {
      start: false,
      move: false,
    };
    mainStore.toggleTouchEvent(payload);
  });

  swiper.on('touchMove', (e) => {
    const x = e.touches.currentX - e.touches.startX;
    const y = e.touches.currentY - e.touches.startY;
    updateCursorPosition(x, y);
    const payload = {
      start: true,
      move: true,
    };
    mainStore.toggleTouchEvent(payload);
  });
};

const toggleHover = (isHover, type = 'default') => {
  const payload = { isHover, type };
  mainStore.toggleTrackingMouse(payload);
};

onMounted(() => {
  document.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });
});

onUnmounted(() => {
  document.removeEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });
});

</script>

<style lang="scss" scoped>
.testimonial-slider {
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
}
</style>
